import { StageInterface } from "@/v2/types/StageInterface";

const sumAllStagesRevenue = (stages: StageInterface[]) => {
  if (!stages || !Array.isArray(stages) || stages.length === 0) {
    return 0;
  }

  return stages.reduce((total, stage) => {
    return total + (stage.revenue.settled ?? 0);
  }, 0);
};

export default sumAllStagesRevenue;
